import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import { createStore } from './Store';

import ScrollToTop from './Components/ScrollToTop';

import HomePage from './pages/home';
import EnterPage from './pages/enter';
import MyEntriesPage from './pages/entries';
import DrawingsPage from './pages/drawings';
import DrawResultPage from './pages/drawResult';
import RulesPage from './pages/rules';
import FaqsPage from './pages/faqs';
import FeedbackPage from './pages/feedback';
import TermsOfUsePage from './pages/terms';
import PrivacyPolicyPage from './pages/privacy';
import LegalPage from './pages/legal';
import LogoutPage from './pages/logout';
import LoginPage from './pages/login';
import PromotionsPage from './pages/promotions';
import PromotionDetailPage from './pages/promotionDetail';
import PageNotFound from './pages/404';
import TestJackpot from './pages/jackpot-test';
import './styling/global.scss';
import promotionConfig from './promotionConfig';

ReactDOM.render(
    <React.StrictMode>
        <Provider store={createStore()}>
            <Router basename={promotionConfig.appPath}>
                <ScrollToTop />
                <Switch>
                    <Route exact path='/' component={HomePage} />
                    <Route path='/home' component={HomePage} />
                    <Route path='/promotions' component={PromotionsPage} />
                    <Route path='/promotion/:promo' component={PromotionDetailPage} />
                    <Route path='/enter' component={EnterPage} />
                    <Route path='/myentries' component={MyEntriesPage} />
                    <Route path='/drawingsandwinners' component={DrawingsPage} />
                    <Route path='/drawresults' component={DrawResultPage} />
                    <Route path='/rules' component={RulesPage} />
                    <Route path='/faqs' component={FaqsPage} />
                    <Route path='/feedback' component={FeedbackPage} />

                    <Route path='/terms' component={TermsOfUsePage} />
                    <Route path='/privacy' component={PrivacyPolicyPage} />
                    <Route path='/legal' component={LegalPage} />

                    <Route path='/jackpot-test' component={TestJackpot} />

                    <Route path='/login' component={LoginPage} />
                    <Route path='/logout' component={LogoutPage} />
                    <Route path='*' component={PageNotFound} />
                </Switch>
            </Router>
        </Provider>
    </React.StrictMode>,
    document.getElementById('root')
);
